<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div *ngIf="isMobileOrTablet" class="block-overlay">
  <div class="block-message">
    <h2>Not Supported</h2>
    <p>This application is only accessible from a Desktop or Laptop.</p>
  </div>
</div>

<div class="page-holder align-items-center bg-white-100 vh-100" *ngIf="!isMobileOrTablet">
  <div class="container" style="max-width: 100%;">
    <div class="row align-items-center">

      <div class="col-lg-4 " style="padding-left: 0px;padding-right: 0px;">
        <div>
          <img src="../../assets/img/login_image.png" alt="login" height="650" style="width: 100%;">

          <button class="btn btn-primary text-white px-2 reload_text imgOverButton">
            <a href="https://www.astakenis.com/" target="_blank">
              <img src="../../assets/img/flash-circle.svg" alt="circle" height="30px;">&nbsp;&nbsp;
              <img *ngIf="orgImgDetails?.oneQmsImageFileName && !orgDetailsFound" class="org-image"
                src="../../assets/img/{{orgImgDetails?.oneQmsImageFileName}}" alt="logo" width="50" height="15">
              <img *ngIf="orgDetailsFound" class="org-image" src="../../assets/img/oneqmslogo.png" alt="logo" width="50"
                height="15">
            </a>
          </button>

          <button *ngIf="orgImgDetails?.loginpageContent" class="text-white px-2 reload_text imgOverButton1">
            <img src="../../assets/img/microscope.svg" alt="content" height="20px;" style="float: left;">
            <br>
            <span [innerHTML]="orgImgDetails?.loginpageContent" style="font-size: 11px;"></span>
          </button>
        </div>
      </div>

      <!-- register -->
      <div class="col-lg-8 px-lg-4" *ngIf="showRegisterBox">
        <div class="card">
          <div class="card-header px-lg-5">
            <div class="card-heading text-primary">Jassa Register</div>
          </div>
          <div class="card-body p-lg-5">
            <h3 class="mb-4">Get started with Chamkila</h3>
            <p class="text-muted text-sm mb-5">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
              tempor incididunt ut labore.</p>
            <form action="index.html">
              <div class="form-floating mb-3">
                <input class="form-control" id="username" type="email" placeholder="name@example.com" required>
                <label for="username">Username</label>
              </div>
              <div class="form-floating mb-3">
                <input class="form-control" type="email" placeholder="name@example.com" required>
                <label for="floatingInput">Email address</label>
              </div>
              <div class="form-floating mb-3">
                <input class="form-control" type="password" placeholder="Password" required noCopyPaste>
                <label for="floatingPassword">Password</label>
              </div>
              <div class="form-check mb-3">
                <input class="form-check-input" type="checkbox" name="agree" id="agree">
                <label class="form-check-label" for="agree">I agree with the <a href="#">Terms & Conditions</a>.</label>
              </div>
              <div class="form-group">
                <button class="btn btn-primary" id="regidter" type="button" name="registerSubmit">Register</button>
              </div>
            </form>
          </div>
          <div class="card-footer px-lg-5 py-lg-4">
            <div class="text-sm text-muted">Already have an account? <a (click)="user_login()">Login</a>.</div>
          </div>
        </div>
      </div>
      <div class="col-lg-8  text-primary rightSideDesign card">
        <label for="logo" class="loginName">
          <img *ngIf="orgImgDetails?.oneQmsImageFileName && !orgDetailsFound" class="org-image"
            src="../../assets/img/{{orgImgDetails?.oneQmsImageFileName}}" alt="logo" style="height: 35px;width: 15%;">
          <img *ngIf="orgDetailsFound" class="org-image" src="../../assets/img/oneqmslogo.png" alt="logo"
            style="height: 35px;width: 15%;">
        </label>

        <!-- LOGIN -->
        <div class="" *ngIf="showLoginBox">
          <div style="padding: 140px;padding-left: 25%;padding-right: 30%;">
            <h4 class="mb-4" style="color: #0F3659;">Hi, Welcome Back!</h4>

            <form action="index.html" #form="ngForm" autocomplete="off">
              <div class="form-floating mb-3">
                <div>
                  <label for="u-name">Username</label>
                </div>
                <div>
                  <input class="form-control" type="text" name="floatingInput1" id="floatingInput1"
                    [(ngModel)]="userSettings.userName" placeholder="Enter your username" required autocomplete="off"
                    (focusout)="onFocusOutEvent($event)">

                </div>
              </div>

              <div class="form-floating mb-3">
                <div><label for="pwd">Password</label></div>
                <div class="d-flex align-items-center">
                  <input class="form-control" name="floatingPassword1" [type]="isPassword ? 'password' : 'text'"
                    id="floatingPassword1" [(ngModel)]="userSettings.password" placeholder="Enter your password"
                    required autocomplete="off" onpaste="return false;" ondrop="return false;" noCopyPaste>
                  <span class="eyeicon-container eye-color" (keydown.enter)="showPassword()" (click)="showPassword()">
                    <i [class]="isPassword ? 'fas fa-eye-slash' : 'fa fa-fw fa-eye field-icon toggle-password'"></i>
                  </span>
                </div>
              </div>

              <div *ngIf="showOrganizationBox">
                <div class="form-floating mb-3">
                  <div><label for="org-name">Organization Name</label></div>
                  <div>
                    <input class="form-control" type="text" [(ngModel)]="userSettings.orgName"
                      placeholder="Organization Name" [ngModelOptions]="{ standalone: true }" required>
                  </div>
                </div>
              </div>

              <div class="form-check mb-3" style="text-align: end;">
                <label for="pwd" (keydown.enter)="forgot_Password()" (click)="forgot_Password()">
                  Forgot Password?
                </label>
              </div>
              <div class="form-floating mb-3" *ngIf="captchaVisible">
                <div class="captcha-container {{ config.cssClass }}">
                  <div class="d-flex flex-wrap recaptcha-input">
                    <div class="captcha-actions">
                      <input type="text" [(ngModel)]="captcha_input" name="captcha"
                        [ngModelOptions]="{standalone: true}" placeholder="Enter the CAPTCHA" (input)="checkCaptcha()">
                    </div>
                    <canvas id="captchaCanvas" width="325" height="80"></canvas>
                    <a class="cpt-btn mt-1" style="text-decoration: none !important;"
                      (click)="reloadCaptcha()">&#x21bb;</a>
                  </div>
                </div>
              </div>
              <div class="textalign">
                <div class="d-flex gap-3">
                  <span class="button-continer" style="width: 100%;">
                    <button style="width: 100%;" class="addIconContiner text-white px-4 reload_text"
                      (click)="captchaValidation()">
                      Login
                    </button>
                  </span>
                </div>
              </div>
            </form>
          </div>
        </div>

        <!-- FORGOT PASSWORD -->
        <div class="" *ngIf="forgotPasswordBox">
          <div style="padding: 120px;">
            <h4 class="mb-4" style="color: #0F3659;">Forgot Password</h4>
            <form action="index.html">
              <div class="form-floating mb-3">
                <div><label for="org-name">Organization Name</label></div>
                <div>
                  <input class="form-control" id="organisationName" type="text" [(ngModel)]="userSettings.orgName"
                    placeholder="Organization Name" [ngModelOptions]="{standalone: true}" required>
                </div>
              </div>
              <div class="form-floating mb-3">
                <div><label for="u-name">Username</label></div>
                <div>
                  <input class="form-control" type="text" [(ngModel)]="userSettings.userName"
                    [ngModelOptions]="{standalone: true}" placeholder="Username" required>
                </div>
              </div>
              <div class="form-floating mb-3">
                <div><label for="email">Email address</label></div>
                <div>
                  <input class="form-control" type="text" [(ngModel)]="userSettings.emailAddress"
                    placeholder="Email address" [ngModelOptions]="{standalone: true}" required>
                </div>
              </div>
              <div class="form-check mb-3" style="text-align: end;">
                <div class="text-sm text-muted">Already have an account? <a (click)="user_login()">Login</a>.</div>
              </div>
              <div class="form-group textalign">
                <button class="col-sm-3" mat-raised-button color="primary"
                  (click)="send_forgot_Password()">Send</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="row align-items-center ">
      <div class="d-flex justify-content-center">Disclaimer Content!</div>
    </div>
  </div>
</div>

<ng-template #confirmationPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelConfirmation()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Confirmation</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 10px 10px;">
    <div>
      <div class="row">
        <p>To enhance the performance and speed of the app, we recommend clearing the cache periodically. This will help
          free up storage space and allow the app to run more smoothly.</p>
      </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="okConfirmation()">
        OK
      </button>
    </div>
  </div>
</ng-template>

<ng-template #sessionAlertPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="closeSessionAlertPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Active Session Detected </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 10px 10px;">
    <div>
      <div class="session-message">

        <div class="warning-text">
          <i class="fa fa-exclamation-circle"></i>
          <span>This user is already logged in on another device.</span>
        </div>

        <div class="session-details">
          <div class="detail-row">
            <span class="label">Device</span>
            <span class="value">
              {{loginResult.ACTIVE_BROWSER}} on {{loginResult.ACTIVE_OS}}
            </span>
          </div>

          <div class="detail-row">
            <span class="label">Last Accessed</span>
            <span class="value">
              {{ loginResult.ACTIVE_LAST_ACCESS | date:'dd-MMM-yyyy HH:mm:ss' }} (GMT)
            </span>
          </div>
        </div>

      </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="override()" *ngIf="parallelSessionAllowed">
        Override
      </button>
      <button mat-stroked-button class="deleteButton" (click)="closeSessionAlertPopup()">
        OK
      </button>
    </div>
  </div>
</ng-template>
